import React from 'react'
import { Box, Button } from '@material-ui/core'

import useStyles from '../../styles'
import { ChevronLeft, ChevronRight } from '@material-ui/icons'

const ButtonAction = ({
  isLastLesson,
  handleNextLesson,
  isCompleting,
  handlePrevLesson,
  prevLessonId,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.navigation}>
      <Button
        variant="outlined"
        size="small"
        startIcon={<ChevronLeft />}
        onClick={handlePrevLesson}
        disabled={!prevLessonId}
        className={classes.prevButton}
      >
        ANTERIOR
      </Button>

      <Button
        variant="contained"
        size="small"
        endIcon={<ChevronRight />}
        onClick={handleNextLesson}
        disabled={isCompleting}
        className={classes.nextButton}
      >
        {isLastLesson ? 'CONCLUIR CURSO' : 'PRÓXIMO'}
      </Button>
    </Box>
  )
}

export default ButtonAction
